module.exports = __webpack_public_path__ + "img/category-etc.f3bfd876.svg";